import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import {CommonModule} from '@angular/common'
import { NgChartsModule } from 'ng2-charts';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-score-vs-percentile',
  templateUrl: './score-vs-percentile.component.html',
  styleUrls: ['./score-vs-percentile.component.scss'],
  standalone: true,
  imports: [CommonModule, NgChartsModule, MatTabsModule]
})
export class ScoreVsPercentileComponent implements OnInit{
  percentileList: any[] = ['99.5', '99', '98', '95', '90', '85', '80'];
  scoreList: any[] = ['41', '46', '51', '59', '76', '84', '93'];
  scoreList1: any[] = ['17', '22', '23', '28', '35', '39', '45'];
  scoreList2: any[] = ['15', '17', '19', '23', '28', '30', '36'];
  scoreList3: any[] = ['11', '13', '16', '20', '27', '29', '32'];
  canvas: any;
  ctx: any;
  canvas1: any;
  ctx1: any;
  canvas2: any;
  ctx2: any;
  canvas3: any;
  ctx3: any;
  @Input('pageName') pageName: any;
  ngOnInit(): void {
    
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      this.canvas = document.getElementById('myChart');
      if(this.canvas){
        this.ctx = this.canvas.getContext('2d');
        let myChart = new Chart(this.ctx, {
          type: 'line',
          data: {
            labels: this.scoreList,
            datasets: [{
              label: '',
              data: this.percentileList.reverse(),
              backgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              borderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              borderWidth: 2,
              pointBorderColor:this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              pointBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              pointBorderWidth: 1,
              pointHoverBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              pointHoverBorderColor:this.pageName == 'score' ? '#2ca87f' : '#feed3f',
              pointHoverBorderWidth: 2,
              pointStyle: 'circle',
              pointRadius: 10,
              pointHoverRadius: 15,
              fill: false
            }]
          },
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (tooltipItem: any) {
                    return "Percentile: " + Number(tooltipItem.raw) + ', Score: ' + Number(tooltipItem.label);
                  }
                }
              },
              legend: { display: false },
    
            },
    
            aspectRatio: 1.8,
            scales: {
              y: {
                display: true,
                grid: {
                  display: false,
                },
                ticks: {
                  color: "rgba(255,255,255,1)"
                }
              },
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  color: "rgba(255,255,255,1)"
                }
              }
            }
           
          },
    
        });
      }
    }, 1000)
   
  }

  onTabChanged(ev: any) {
    if (ev.index == 1) {
      this.canvas1 = document.getElementById('myChart1');
      this.ctx1 = this.canvas1.getContext('2d');
      let myChart1 = new Chart(this.ctx1, {
        type: 'line',
        data: {
          labels: this.scoreList1,
          datasets: [{
            label: '',
            data: this.percentileList,
            backgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderWidth: 2,
            pointBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBackgroundColor:this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBorderWidth: 1,
            pointHoverBackgroundColor:this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderWidth: 2,
            pointStyle: 'circle',
            pointRadius: 10,
            pointHoverRadius: 15,
            fill: false
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem: any) {
                  return "Percentile: " + Number(tooltipItem.raw) + ', Score: ' + Number(tooltipItem.label);
                }
              }
            },
            legend: { display: false },

          },

          aspectRatio: 1.8,
          scales: {
            y: {
              display: true,
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            }
          }
          // scales: {
          //   xAxes: [{
          //     gridLines: {
          //       display: false,
          //     },
          //     ticks: {
          //       fontColor: "#fff",
          //     },
          //   }],
          //   yAxes: [{
          //     display: true,
          //     gridLines: {
          //       display: false,
          //     },
          //     ticks: {
          //       fontColor: "#fff", // this here
          //     },
          //   }],
          // }
        },

      });
    } else if (ev.index == 2) {
      this.canvas2 = document.getElementById('myChart2');
      this.ctx2 = this.canvas2.getContext('2d');
      let myChart2 = new Chart(this.ctx2, {
        type: 'line',
        data: {
          labels: this.scoreList2,
          datasets: [{
            label: '',
            data: this.percentileList,
            backgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderColor:this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderWidth: 2,
            pointBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBorderWidth: 1,
            pointHoverBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderWidth: 2,
            pointStyle: 'circle',
            pointRadius: 10,
            pointHoverRadius: 15,
            fill: false
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem: any) {
                  return "Percentile: " + Number(tooltipItem.raw) + ', Score: ' + Number(tooltipItem.label);
                }
              }
            },
            legend: { display: false },

          },

          aspectRatio: 1.8,
          scales: {
            y: {
              display: true,
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            }
          }

        },

      });
    } else if (ev.index == 3) {
      this.canvas3 = document.getElementById('myChart3');
      this.ctx3 = this.canvas3.getContext('2d');
      let myChart3 = new Chart(this.ctx3, {
        type: 'line',
        data: {
          labels: this.scoreList3,
          datasets: [{
            label: '',
            data: this.percentileList,
            backgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderWidth: 2,
            pointBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBorderWidth: 1,
            pointHoverBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderWidth: 2,
            pointStyle: 'circle',
            pointRadius: 10,
            pointHoverRadius: 15,
            fill: false
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem: any) {
                  return "Percentile: " + Number(tooltipItem.raw) + ', Score: ' + Number(tooltipItem.label);
                }
              }
            },
            legend: { display: false },

          },

          aspectRatio: 1.8,
          scales: {
            y: {
              display: true,
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            }
          }

        },

      });
    } else {
      this.canvas = document.getElementById('myChart');
      this.ctx = this.canvas.getContext('2d');
      let myChart = new Chart(this.ctx, {
        type: 'line',
        data: {
          labels: this.scoreList,
          datasets: [{
            label: '',
            data: this.percentileList,
            backgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            borderWidth: 2,
            pointBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointBorderWidth: 1,
            pointHoverBackgroundColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderColor: this.pageName == 'score' ? '#2ca87f' : '#feed3f',
            pointHoverBorderWidth: 2,
            pointStyle: 'circle',
            pointRadius: 10,
            pointHoverRadius: 15,
            fill: false
          }]
        },
        options: {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: function (tooltipItem: any) {
                  return "Percentile: " + Number(tooltipItem.raw) + ', Score: ' + Number(tooltipItem.label);
                }
              }
            },
            legend: { display: false },

          },

          aspectRatio: 1.8,
          scales: {
            y: {
              display: true,
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "rgba(255,255,255,1)"
              }
            }
          }

        },

      });
    }
  }

}
